
<main>
  
  <router-outlet></router-outlet>
  
  <app-cookie-consent></app-cookie-consent>
</main>
<app-footer></app-footer>

